import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-466">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-467" />
      <div ref={modalRef} className="relative w-full max-w-2xl bg-[#fbf7dd] rounded-xl shadow-2xl overflow-hidden transform transition-all max-h-[90vh] overflow-y-auto" data-id="element-468">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors z-10" data-id="element-469">
          <X className="h-6 w-6" data-id="element-470" />
        </button>
        <div className="p-6 sm:p-8" data-id="element-471">{children}</div>
      </div>
    </div>;
}